export const ASSIGN_OPERATIONAL_FORM_TASK_CMD = "assign-form-task";

export const RESPONSE_OPERATIONAL_FORM_CMD = "response-operational-form";

const ASSIGN_OPERATIONAL_FORM_TASK_SLUGS = new Set([
  "assign_form_task",
  "assign_operational_form_task",
]);

const RESPONSE_OPERATIONAL_FORM_SLUGS = new Set([
  "response_operational_form",
]);

export function toMergeableCmdData(value) {
  return value && typeof value === "object" ? { ...value } : {};
}

export function readAssignOperationalFormComment(data) {
  if (!data || typeof data !== "object") {
    return "";
  }
  const value = data.comment ?? data.input;
  return typeof value === "string" ? value.trim() : "";
}

function canonicalizeCmdSlug(raw) {
  if (raw == null) {
    return "";
  }
  return String(raw).trim().toLowerCase().replace(/-/g, "_");
}

export function collectCmdSlugs(data) {
  if (!data || typeof data !== "object") {
    return [];
  }
  return [data.cmd, data.command, data.cmd_name, data.cmd_label]
    .map(canonicalizeCmdSlug)
    .filter(Boolean);
}

export function isResponseOperationalFormCmd(data) {
  return collectCmdSlugs(data).some((slug) =>
    RESPONSE_OPERATIONAL_FORM_SLUGS.has(slug)
  );
}

export function isAssignOperationalFormTaskCmd(data) {
  return collectCmdSlugs(data).some((slug) =>
    ASSIGN_OPERATIONAL_FORM_TASK_SLUGS.has(slug)
  );
}

export function isAssignOperationalFormTaskByRequirements(requirements) {
  if (!Array.isArray(requirements) || !requirements.length) {
    return false;
  }
  const types = new Set(
    requirements.map((requirement) => requirement && requirement.type).filter(Boolean)
  );
  if (!types.has("operational_form_template")) {
    return false;
  }
  return types.has("users") || types.has("user");
}

export function isAssignOperationalFormTaskStackEntry(entry) {
  if (!entry || entry.type !== "cmd") {
    return false;
  }
  if (isAssignOperationalFormTaskCmd(entry)) {
    return true;
  }
  return isAssignOperationalFormTaskByRequirements(entry.requirements);
}

export function isAssignOperationalFormTaskNodeData(data) {
  if (!data || typeof data !== "object") {
    return false;
  }
  if (isAssignOperationalFormTaskCmd(data)) {
    return true;
  }
  if (isAssignOperationalFormTaskByRequirements(data.requirements)) {
    return true;
  }
  const stack = data.filled_stack;
  if (!Array.isArray(stack)) {
    return false;
  }
  return stack.some(isAssignOperationalFormTaskStackEntry);
}

export function isAssignOperationalFormTaskEditorContext(nodeInfo, requirements) {
  if (isAssignOperationalFormTaskCmd(nodeInfo)) {
    return true;
  }
  return isAssignOperationalFormTaskByRequirements(requirements);
}
